export const PasswordStorage = {
  PASSWORD_NOT_SET_FLAG: "PASSWORD_NOT_SET_FLAG",
};
